import ConfigClient from 'clients/config-client'
import { AnyAction } from 'redux'
import { change } from 'redux-form'
import { from, Observable } from 'rxjs'
import { filter, flatMap, map, mergeMap } from 'rxjs/operators'
import { defaultCatchError } from '../app/app-epics'
import { actionCubitSnackbarShow } from '../cubit-snackbar/cubit-snackbar-actions'
import {
    actionPeriodConfigurationsGetSuccess,
    actionTenantConfigGetSuccess,
    actionTenantConfigSaveSuccess,
    ACTION_PERIODCONFIGURATIONS_GET,
    ACTION_TENANTCONFIG_GET,
    ACTION_TENANTCONFIG_SAVE,
    ACTION_TENANTCONFIG_TEST,
} from './config-action'
import { combineEpics } from 'redux-observable'

export const getTenantConfig = (action$: Observable<AnyAction>): Observable<AnyAction> =>
    action$.pipe(
        filter((x) => x.type === ACTION_TENANTCONFIG_GET),
        flatMap(
            (action): Observable<AnyAction> =>
                ConfigClient.getTenantConfig().pipe(
                    map((tenantConfig) => actionTenantConfigGetSuccess(tenantConfig)),
                    defaultCatchError(),
                ),
        ),
    )

export const saveTenantConfig = (action$: Observable<AnyAction>): Observable<AnyAction> =>
    action$.pipe(
        filter((x) => x.type === ACTION_TENANTCONFIG_SAVE),
        flatMap(
            (action): Observable<AnyAction> =>
                ConfigClient.updateTenantConfig(action.tenantConfig).pipe(
                    map((tenantConfig) => actionTenantConfigSaveSuccess(tenantConfig)),
                    defaultCatchError(),
                ),
        ),
    )

export const testTenantConfig = (action$: Observable<AnyAction>): Observable<AnyAction> =>
    action$.pipe(
        filter((x) => x.type === ACTION_TENANTCONFIG_TEST),
        flatMap(
            (action): Observable<AnyAction> =>
                ConfigClient.testTenantConfig(action.tenantConfig).pipe(
                    mergeMap((result) =>
                        from([
                            change(
                                'tenantConfigForm',
                                'vismaConfiguration.commoditySettings.principalNumbers',
                                result.tenantConfig.vismaConfiguration.commoditySettings.principalNumbers,
                            ),
                            change(
                                'tenantConfigForm',
                                'vismaConfiguration.commoditySettings.commodityPrincipalMappings',
                                result.tenantConfig.vismaConfiguration.commoditySettings
                                    .commodityPrincipalMappings,
                            ),
                            actionCubitSnackbarShow([result.message], result.success ? 'success' : 'error'),
                        ]),
                    ),
                    defaultCatchError(),
                ),
        ),
    )

export const getPeriodConfigurations = (action$: Observable<AnyAction>): Observable<AnyAction> =>
    action$.pipe(
        filter((x) => x.type === ACTION_PERIODCONFIGURATIONS_GET),
        flatMap(
            (action): Observable<AnyAction> =>
                ConfigClient.getPeriodConfigurations().pipe(
                    map((periodConfigs) => actionPeriodConfigurationsGetSuccess(periodConfigs)),
                    defaultCatchError(),
                ),
        ),
    )

export const configEpics = combineEpics(getTenantConfig, saveTenantConfig, testTenantConfig, getPeriodConfigurations)
